import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * Modèle pour gérer le message défilant dans la navbar
 */

// ID du document dans Firestore qui contient le message défilant
const MARQUEE_DOC_ID = 'marquee_settings';

/**
 * Récupère le message défilant actuel depuis Firestore
 * @returns {Promise<Object>} Le message et sa vitesse
 */
export const getMarqueeMessage = async () => {
  try {
    const marqueeRef = doc(db, 'settings', MARQUEE_DOC_ID);
    const marqueeDoc = await getDoc(marqueeRef);
    
    if (marqueeDoc.exists()) {
      return marqueeDoc.data();
    } else {
      // Message par défaut si aucun n'est défini
      return {
        message: '🌱 Agri Vision Gabon regroupe agriculteurs et éleveurs pour structurer et dynamiser les filières agricoles et d\'élevage au Gabon. ✅ Réduire la dépendance alimentaire ✅ Renforcer l\'autonomie des producteurs ✅ Assurer une production locale stable et compétitive',
        speed: 30 // Vitesse par défaut en secondes
      };
    }
  } catch (error) {
    console.error('Erreur lors de la récupération du message défilant:', error);
    // Retourner un message par défaut en cas d'erreur
    return {
      message: '🌱 Agri Vision Gabon regroupe agriculteurs et éleveurs pour structurer et dynamiser les filières agricoles et d\'élevage au Gabon.',
      speed: 30
    };
  }
};

/**
 * Met à jour le message défilant dans Firestore
 * @param {string} message - Le nouveau message à afficher
 * @param {number} speed - La vitesse de défilement en secondes
 * @returns {Promise<boolean>} - True si la mise à jour a réussi
 */
export const updateMarqueeMessage = async (message, speed) => {
  try {
    const marqueeRef = doc(db, 'settings', MARQUEE_DOC_ID);
    await setDoc(marqueeRef, {
      message,
      speed,
      updatedAt: new Date()
    }, { merge: true });
    
    return true;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du message défilant:', error);
    return false;
  }
};